const SvgDevOps2 = (props) => (
  <>
    <path fill={props.p30} d="M6 168v-48l42-24 42 24v48l-42 24-42-24z" />
    <path fill={props.p20} d="M102 168v-48l42-24 42 24v48l-42 24-42-24z" />
    <path fill={props.p10} d="M54 88V40l42-24 42 24v48l-42 24-42-24z" />
  </>
);

export default SvgDevOps2;
